export interface Analytics {
  id: number;
}

export interface AnalyticsResponse {
  list: Analytics[];
}

interface Serie {
  name: string;
  value: number;
}
export interface AnalyticsItem {
  name: string;
  series: Serie[];
}
interface ContextsComMaiveaiUser {
  mj_job_id: number;
}
interface ContextsComMaiveaiJob {
  mj_job_id: number;
}
export interface AnalyticsData {
  _index: string;
  _type: string;
  _id: string;
  _score: number;
  _source: {
    contexts_com_maiveai_user_1: ContextsComMaiveaiUser[];
    page_title: string;
    event_name: string;
    contexts_com_maiveai_job_1: ContextsComMaiveaiJob[];
    page_referrer: string;
    platform: string;
  };
}
export interface FunnelData {
  _index: string;
  _type: string;
  _id: string;
  _score: number;
  _source: {
    page_title: string;
    geo_latitude: number;
    geo_region_name: string;
    geo_city: string;
    geo_longitude: number;
    event_name: string;
    page_referrer: string;
    platform: string;
  };
}

export const stacked_area_chart_ui = {
  // View: the dimensions of the chart [width, height].
  // If left undefined, the chart will fit to the parent container size
  // view: [700, 400],
  showXAxis: true,
  showYAxis: true,
  gradient: false,
  showLegend: true,
  showXAxisLabel: true,
  animations: true,
  showYAxisLabel: true,
  legendTitle: 'Referrals',
  xAxisLabel: '',
  yAxisLabel: 'Page views',
  colorScheme: {
    domain: [
      '#46BBB3',
      '#ED663C',
      '#12B1C5',
      '#FF9718',
      '#2a7c9e',
      '#ffdfb9',
      '#c7eae8',
      '#f2d2d2',
      '#b7e7ed',
    ],
  },
};
